angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsAccountsV2', function ($q, $log, EventManager, TeacherDataService) {
  return {
    templateUrl: 'template.html',
    scope: {
      selectedClass: '='
    },
    link: function (scope, element) {

      /**
       * THIS PAGE ONLY SHOWS UP TO THE USERS LISTED UNDER
       * teacher-students/ scope.showAccountsTab
       */

      $log.error('teacherStudentsAccountsV2 :::: should not be appearing')

    }
  }
});
